import { ActionsButtonItem, LoadedActionsButtonItem, SetAction } from './actions-button.types';

export function makeDefineActions<A extends string, T extends (...args: any) => any>(
  actions: ActionsButtonItem<A, any>[],
  showActionsPredicate?: T,
  validateAction?: (action: A) => boolean
) {
  return function defineActions<P extends Parameters<T>>(setAction: SetAction<A>, ...args: P) {
    function loadAction(actionItem: ActionsButtonItem<A>): LoadedActionsButtonItem {
      return {
        ...actionItem,
        action: () => setAction(actionItem.action, actionItem.payload)
      };
    }

    if (showActionsPredicate && !showActionsPredicate(args)) return [];
    return actions
      .filter((actionItem) => (validateAction ? validateAction(actionItem.action) : true))
      .map((actionItem) => loadAction(actionItem));
  };
}
